/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetAccessRequestNotificationSettingsResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOkFromDiscriminatorValue, serializeOk, serializeUpdateAccessRequestNotificationSettingsRequest, type ErrorResponse, type GetAccessRequestNotificationSettingsResponse, type InternalErrorResponse, type Ok, type UpdateAccessRequestNotificationSettingsRequest } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/access-request-notification-settings
 */
export interface AccessRequestNotificationSettingsRequestBuilder extends BaseRequestBuilder<AccessRequestNotificationSettingsRequestBuilder> {
    /**
     * Returns the email address notified when a new access request is submitted to the organization, plus the effective address after falling back to the organization's contact email when none is configured.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetAccessRequestNotificationSettingsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<GetAccessRequestNotificationSettingsResponse | undefined>;
    /**
     * Sets the email address notified when a new access request is submitted to the organization. A blank value clears the setting, after which notifications fall back to the organization's contact email.
     * @param body Sets who is emailed when a new access request is submitted to the organization.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateAccessRequestNotificationSettingsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Returns the email address notified when a new access request is submitted to the organization, plus the effective address after falling back to the organization's contact email when none is configured.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Sets the email address notified when a new access request is submitted to the organization. A blank value clears the setting, after which notifications fall back to the organization's contact email.
     * @param body Sets who is emailed when a new access request is submitted to the organization.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateAccessRequestNotificationSettingsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const AccessRequestNotificationSettingsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/access-request-notification-settings";
/**
 * Metadata for all the requests in the request builder.
 */
export const AccessRequestNotificationSettingsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: AccessRequestNotificationSettingsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetAccessRequestNotificationSettingsResponseFromDiscriminatorValue,
    },
    put: {
        uriTemplate: AccessRequestNotificationSettingsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateAccessRequestNotificationSettingsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
